<mat-form-field>
  <ng-container matPrefix>
    <ng-content select="[plsPrefix]"></ng-content>
  </ng-container>

  <ng-container matSuffix>
    <ng-content select="[plsSufix]"></ng-content>
  </ng-container>

  <input
    matInput
    [autocomplete]="autocomplete"
    [readonly]="readonly"
    [required]="required"
    [matAutocomplete]="auto"
    [max]="max"
    [maxLength]="maxLength"
    [min]="min"
    [minLength]="minLength"
    [pattern]="pattern"
    [placeholder]="placeholder"
    [type]="type"
    [value]="value || ''"
    (blur)="onBlurInput($event)"
    (focus)="pulseFocus.emit($event)"
    (input)="pulseInput.emit($event)"
    #inputNative
  />

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <ng-container *ngIf="!isHTML; else second">
      <mat-option *ngFor="let option of options" [value]="option">
        {{ option.companyServiceName || option }}
      </mat-option>
    </ng-container>

    <ng-template #second>
      <mat-option
        *ngFor="let option of options"
        [value]="option"
        [innerHTML]="option.companyServiceName || option"
      ></mat-option>
    </ng-template>
  </mat-autocomplete>
  <button
    *ngIf="inputNative.value && clearInput"
    mat-button
    matSuffix
    mat-icon-button
    type="button"
    data-test="btnClearTextInput"
    (click)="clearTextInput()"
  >
    <span class="icon-close"></span>
  </button>
</mat-form-field>
